/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
"use client";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import Image from "next/image";
// import CategoryDropdown from "./dropdowns/CategoryDropdown";
import { useSearchParams } from "next/navigation";
import { useDebouncedCallback } from "use-debounce";
import { getBannerImage } from "./bannerImage";
import { ArrowDownIcon } from "../icons";
import ModalSearchCity from "./modals/ModalSearchCity";
import VideoCarousel from "./videoCarousel/videoCarousel";
import CookieConsent from "@/app/[lng]/(use-auth)/cookiesConsent";
import { useTranslation } from "@/app/i18n/client";
import Search from "@/assets/images/icons/search.svg";
import HexagonButton from "@/common/customElements/HexagonButton";
import {
  CustomDiv,
  FakeInputContainer,
  HomeHeaderDiv,
  InlineDiv,
  ResultsAsDropdownContainer,
} from "@/common/divs";
import { InputWithNoBorder } from "@/common/inputs";
import { AlmostBoldText, SemiBoldText } from "@/common/texts";
import { HomeFiltersProps } from "@/types/components";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const HomeHeader: React.FC<HomeFiltersProps> = ({
  city,
  changeValuesForFetch,
  valuesState,
  parseSpecialTerm,
  communities,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [cityState, setCityState] = useState<string>(city);
  useEffect(() => {
    setCityState(city);
  }, [city]);
  const searchParams = useSearchParams();
  const search = searchParams.get("term") ?? "";
  const parseInverseTerm = () => {
    const terms = search.split(" ");
    let inverseTerm = "";
    terms.forEach((term) => {
      if (
        !term.startsWith("cat:") &&
        !term.startsWith("subcat:") &&
        !term.startsWith("tag:") &&
        !term.startsWith("mob:")
      ) {
        inverseTerm += term + " ";
      }
    });
    return inverseTerm.trim();
  };
  const [searchActivity, setSearchActivity] =
    useState<string>(parseInverseTerm());
  const handleChangeActivity = (event: React.ChangeEvent<HTMLInputElement>) => {
    debounced(event.target.value);
    setSearchActivity(event.target.value);
    parseSpecialTerm(event.target.value);
  };

  const { t } = useTranslation();

  const isMobile = useMediaQuery("(max-width:640px)");

  const debounced = useDebouncedCallback((value: string) => {
    if (value.length > 2) {
      getResults(value);
      if (!openResults) {
        setOpenResults(true);
      }
    }
  }, 1000);

  const [possibleResults, setPossibleResults] = useState([]);
  const [openResults, setOpenResults] = useState(false);

  const getResults = async (value: string) => {
    const apiEndpoint = process.env.NEXT_PUBLIC_BACKEND_URL;
    const appToken = process.env.NEXT_PUBLIC_APP_TOKEN!;
    const resp = await fetch(
      `${apiEndpoint}/api/v1/support/search?name=${value}`,
      {
        headers: {
          "app-token": appToken,
        },
      },
    );

    const result = await resp.json();
    if (result) {
      setPossibleResults(result);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      // Llama a la función que hace la búsqueda
      changeValuesForFetch();
    }
  };

  return (
    <>
      <CookieConsent />
      <HomeHeaderDiv className="responsive-header">
        <section className="main-home-section">
          <img
            alt="home-header-image"
            className="image-home-height"
            src={getBannerImage(cityState)}
          ></img>
          <CustomDiv
            paddingX={isMobile ? "10px" : "0px"}
            style={{
              paddingTop: "10px",
              textAlign: isMobile ? "left" : "center",
              marginTop: isMobile ? "50px" : "0px",
            }}
          >
            <AlmostBoldText
              style={{ zIndex: "99", position: "relative" }}
              fontSize={isMobile ? "20px" : "32px"}
              color="#fff"
            >
              {t("home.header_title")}{" "}
              {isMobile ? null : (
                <AlmostBoldText
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ zIndex: "99", position: "relative" }}
                  fontSize={isMobile ? "20px" : "32px"}
                  color={PRIMARY_BUTTON_COLOR}
                >
                  {cityState}
                </AlmostBoldText>
              )}
            </AlmostBoldText>
            {isMobile ?
              <CustomDiv
                className="search-div-button"
                style={{ marginRight: "10px", display: "flex" }}
              >
                <AlmostBoldText
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ zIndex: "99", position: "relative" }}
                  fontSize={isMobile ? "20px" : "32px"}
                  color={PRIMARY_BUTTON_COLOR}
                >
                  {cityState}
                </AlmostBoldText>
                <div style={{ marginTop: "4px", marginLeft: "4px" }}>
                  <HexagonButton
                    onClick={() => {
                      setOpen(true);
                    }}
                    width="30px"
                    backgroundColor={PRIMARY_BUTTON_COLOR}
                  >
                    <div
                      style={{
                        marginTop: "-25px",
                        zIndex: "9",
                        position: "relative",
                        marginLeft: "3px",
                      }}
                    >
                      <ArrowDownIcon color="black" />
                    </div>
                  </HexagonButton>
                </div>
              </CustomDiv>
            : null}
          </CustomDiv>
          {isMobile ? null : <VideoCarousel city={city} />}

          <div style={{ marginTop: isMobile ? "50px" : "15px" }}>
            <InlineDiv
              style={{
                justifyContent: "space-evenly",
                flexWrap: "wrap",
                rowGap: "15px",
              }}
            >
              {isMobile ? null : (
                <FakeInputContainer
                  style={{ width: "20%", justifyContent: "space-between" }}
                  className="inline-filters-bar"
                >
                  <CustomDiv
                    style={{ cursor: "pointer", minWidth: "75%" }}
                    className="insideInputContainer"
                    onClick={() => setOpen(true)}
                  >
                    <SemiBoldText
                      color={NEUTRO_TITLES_COLOR}
                      fontSize="10px"
                      style={{ fontWeight: "600" }}
                    >
                      {t("home.where")}
                    </SemiBoldText>
                    <SemiBoldText
                      className="small-input-container"
                      style={{
                        fontWeight: "300",
                        lineHeight: "15px",
                        marginTop: "2px",
                      }}
                    >
                      {cityState}
                    </SemiBoldText>
                  </CustomDiv>
                  <InlineDiv className="insideInputContainerLast">
                    <CustomDiv
                      className="search-div-button"
                      style={{ marginRight: "10px" }}
                    >
                      <HexagonButton
                        onClick={() => {
                          setOpen(true);
                        }}
                        width="43px"
                        backgroundColor={PRIMARY_BUTTON_COLOR}
                      >
                        <div
                          style={{
                            marginTop: "-30px",
                            zIndex: "9",
                            position: "relative",
                            marginLeft: "10px",
                          }}
                        >
                          <ArrowDownIcon color="black" />
                        </div>
                      </HexagonButton>
                    </CustomDiv>
                  </InlineDiv>
                </FakeInputContainer>
              )}
              <FakeInputContainer
                style={{ width: "60%", justifyContent: "space-between" }}
                className="inline-filters-bar"
              >
                <div
                  className="insideInputContainer"
                  style={{ minWidth: "75%" }}
                >
                  <SemiBoldText
                    color={NEUTRO_TITLES_COLOR}
                    fontSize="10px"
                    style={{ fontWeight: "600" }}
                  >
                    {t("home.activity")}
                  </SemiBoldText>
                  <InputWithNoBorder
                    className="small-input-container"
                    placeholder={t("home.search_adventure")}
                    onKeyDown={handleKeyDown}
                    onChange={handleChangeActivity}
                    value={searchActivity}
                    name="adventure"
                  />
                  {openResults && (
                    <ResultsAsDropdownContainer style={{ marginTop: "20px" }}>
                      {possibleResults.map((element, index) => {
                        return (
                          <div
                            style={{ cursor: "pointer" }}
                            key={index}
                            className="customMenuItem"
                            onClick={() => {
                              setSearchActivity(element);
                              parseSpecialTerm(element);
                              setOpenResults(false);
                            }}
                          >
                            {element}
                          </div>
                        );
                      })}
                    </ResultsAsDropdownContainer>
                  )}
                </div>

                <InlineDiv className="insideInputContainerLast">
                  <CustomDiv
                    className="search-div-button"
                    style={{ marginRight: "10px" }}
                  >
                    <HexagonButton
                      onClick={() => {
                        changeValuesForFetch && changeValuesForFetch();
                      }}
                      width="43px"
                      backgroundColor={PRIMARY_BUTTON_COLOR}
                    >
                      <Image
                        alt="search"
                        width="16"
                        height="16"
                        src={Search.src}
                        style={{
                          position: "absolute",
                          top: "27%",
                          left: "32%",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                    </HexagonButton>
                  </CustomDiv>
                </InlineDiv>
              </FakeInputContainer>
            </InlineDiv>
          </div>
        </section>

        {open && (
          <ModalSearchCity
            open={open}
            setOpen={setOpen}
            communities={communities}
            valuesState={valuesState}
            setCityState={setCityState}
            changeValuesForFetch={changeValuesForFetch}
          />
        )}
      </HomeHeaderDiv>
    </>
  );
};

export default HomeHeader;
